// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3m2NF","column":"style_column__xP_Cx","row":"style_row__1to5y"};